"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _program = require("@studio/program");
var _constants = require("@studio/constants");
var _actions = require("../../../actions");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function attendeeScreenShareRemoved(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var attendeeId = _ref2.attendeeId;
  var _getState = getState(),
    broadcastSources = _getState.broadcastSources,
    program = _getState.program;
  var sources = broadcastSources.sources.filter(function (s) {
    return [attendeeId, "".concat(attendeeId, "#content")].includes(s.value) && s.isInitializing;
  });
  var layers = (0, _program.getProgramLayers)(program);
  if (sources.length) {
    sources.forEach(function (source) {
      var _layers$filter = layers.filter(function (layer) {
          return layer.source._id === source._id;
        }),
        _layers$filter2 = _slicedToArray(_layers$filter, 1),
        layerSource = _layers$filter2[0];

      // Remove if source is in program
      if (!!layerSource) {
        dispatch((0, _actions.toggleProgramSource)(source));
      }
      dispatch((0, _actions.removeAttendeeCamera)(source.value));
      if (source.type === _constants.SCREEN_PRESENTER) {
        dispatch((0, _actions.decreaseScreenShare)());
      }
    });
  }
}
var _default = exports["default"] = attendeeScreenShareRemoved;